import React from 'react';
import './NotFoundPage.css';

export default function NotFoundPage({ onHome, onBack }) {
  return (
    <div className="nf-root">
      <div className="nf-card">
        <div className="nf-code">404</div>
        <h2 className="nf-title">Page not found</h2>
        <p className="nf-sub">The page you're looking for doesn't exist or you don't have access to it.</p>
        <div className="nf-actions">
          <button className="nf-btn nf-btn--primary" onClick={onHome}>Go to dashboard</button>
          {onBack && <button className="nf-btn nf-btn--ghost" onClick={onBack}>Go back</button>}
        </div>
      </div>
    </div>
  );
}
